<section>
  <div *ngIf="isMultiMode | async" class="button-container" [class.-flexEnd]="flexPosition=='right'" [class.-flexBegin]="flexPosition=='left'">
    <button *ngIf="showLeftButton" class="o-button -white" type="button" [disabled]="disablePrevious"
      (click)="emitPrevious($event)">{{previousLabel}}</button>
    <button *ngIf="showRightButton" class="o-button -blue" [type]="nextButtonType" [disabled]="disableNext" style="padding: .565rem 2rem;"
      (click)="emitNext($event)">{{nextLabel}}</button>
  </div>
  <div *ngIf="!(isMultiMode | async)" class="button-container" [class.-flexEnd]="flexPosition=='right'" [class.-flexBegin]="flexPosition=='left'">
    <button *ngIf="showLeftButton" class="o-button -white" type="button" (click)="emitCancel($event)">Cancelar</button>
    <button *ngIf="showRightButton" class="o-button -blue" [type]="okButtonType" [disabled]="disableOk" style="padding: .565rem 2rem;"
      (click)="emitOk($event)">OK</button>
  </div>
</section>